<template>
  <div v-if="isVisible" class="chat-overlay-collapse" :style="containerStyle" @click="handleClick">
    <button class="collapse-button" :style="iconStyle">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useOverlayCustomisation } from '../composables/useOverlayCustomisation';

// Emits
const emit = defineEmits<{
  (e: 'click'): void;
}>();

// Customisation
const customisation = useOverlayCustomisation();

const isVisible = computed(() => {
  return customisation.isVisible.value;
});

const containerStyle = computed(() => {
  const color = customisation.backgroundColor.value;
  return color ? { backgroundColor: color } : {};
});

const iconStyle = computed(() => {
  const color = customisation.iconColor.value;
  return color ? { color } : {};
});

// Methods
const handleClick = () => {
  emit('click');
};
</script>

<style lang="scss" scoped>
.chat-overlay-collapse {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  padding: 8px;
}

.collapse-button {
  background: transparent;
  border: none;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transform: rotate(180deg);

  svg {
    display: block;
  }
}
</style>
